export type AbilityActivation = "passive" | "instant" | "continuous" | "ammo" | "hazard";

export interface AbilityDefinition {
  readonly id: number;
  readonly key: string;
  readonly icon: string;
  readonly activation: AbilityActivation;
  readonly ammo: number;
}

const ability = (id: number, key: string, icon: string, activation: AbilityActivation, ammo = 0): AbilityDefinition => ({ id, key, icon, activation, ammo });

export const ABILITIES: readonly AbilityDefinition[] = Object.freeze([
  ability(1, "jumpboots", "spr_ability_jumpboots", "passive"),
  ability(2, "skeleton", "spr_ability_skeleton", "hazard"),
  ability(3, "mine", "spr_ability_mine", "instant"),
  ability(4, "jetpack", "spr_ability_jetpack", "continuous"),
  ability(5, "floater", "spr_ability_floater", "continuous"),
  ability(6, "teleport", "spr_ability_teleport", "instant"),
  ability(7, "firework", "spr_ability_firework", "instant"),
  ability(8, "waterwalk", "spr_ability_waterwalk", "passive"),
  ability(9, "runner", "spr_ability_runner", "passive"),
  ability(10, "invisibility", "spr_ability_invisibility", "passive"),
  ability(11, "flash", "spr_ability_flash", "passive"),
  ability(12, "laser", "spr_ability_laser", "instant"),
  ability(13, "clustermine", "spr_ability_clustermine", "instant"),
  ability(14, "assasin", "spr_ability_assasin", "instant"),
  ability(15, "slow", "spr_ability_slow", "passive"),
  ability(16, "nade", "spr_ability_nade", "ammo", 3),
  ability(17, "flashnade", "spr_ability_flashnade", "ammo", 3),
  ability(18, "reverse", "spr_ability_reverse", "passive"),
  ability(19, "random", "spr_ability_random", "hazard"),
  ability(20, "fireball", "spr_ability_fireball", "ammo", 3),
  ability(21, "cluster", "spr_ability_cluster", "instant"),
  ability(22, "superkick", "spr_ability_superkick", "instant"),
  ability(23, "frog", "spr_ability_frog", "passive"),
  ability(24, "floordestroyer", "spr_ability_floordestroyer", "instant"),
  ability(25, "bomber", "spr_ability_bomber", "instant"),
  ability(26, "nowalls", "spr_ability_nowalls", "instant"),
  ability(27, "matrix", "spr_ability_matrix", "instant"),
  ability(28, "freezerball", "spr_ability_freezerball", "ammo", 3),
  ability(29, "nobonus", "spr_ability_nobonus", "instant"),
  ability(30, "destroyer", "spr_ability_destroyer", "instant"),
  ability(31, "bomb", "spr_ability_bomb", "instant"),
  ability(32, "walldisappearer", "spr_ability_walldisappearer", "instant"),
  ability(33, "fireman", "spr_ability_fireman", "passive"),
  ability(34, "teleporter", "spr_ability_teleporter", "ammo", 3),
  ability(35, "freeze", "spr_ability_freeze", "hazard"),
  ability(36, "pistol", "spr_ability_pistol", "instant"),
  ability(37, "wallappears", "spr_ability_wallappears", "instant"),
  ability(38, "waterwalks", "spr_ability_waterwalks", "instant"),
  ability(39, "skeletondestroy", "spr_ability_skeleton_destroy", "instant"),
  ability(40, "walldestroy", "spr_ability_walldestroy", "hazard"),
  ability(41, "hoverball", "spr_ability_hoverball", "ammo", 3),
  ability(42, "norope", "spr_ability_norope", "instant"),
  ability(43, "runbomb", "spr_ability_runbomb", "instant"),
  ability(44, "parachute", "spr_ability_parachute", "continuous"),
  ability(45, "weasel", "spr_ability_weasel", "instant"),
  ability(46, "net", "spr_ability_net", "instant"),
  ability(47, "magnet", "spr_ability_magnet", "continuous"),
  ability(48, "flamethrower", "spr_ability_fireman", "ammo", 30)
]);

export const abilityById = (id: number): AbilityDefinition | undefined => ABILITIES[id - 1];
export const ALL_ABILITY_IDS: readonly number[] = Object.freeze(ABILITIES.map(({ id }) => id));
